<template>
  <div class="pb-[10] bg-[#fff] h-[100%]">
    <dg-head>
      <div class="flex items-center">
        <p class="cursor-pointer  pr-[40]" @click="push({ path: '/login' })"> <i class="icon">&#xe6c4;</i> 登录</p>
        <a :href="ENV.official" target="_blank"> <el-button size="mini" type="primary">返回首页</el-button></a>
      </div>
    </dg-head>
    <div class="min-h-[84vh] pt-[84] md:pt-[50] md:min-h-[80vh]">
      <div class="w-[400] mx-[auto]">
        <p class="text-center font-500 t-[24] pb-[24] t-[#333]">忘记密码</p>
        <div class="pb-[5]" v-if="tips.msg">
          <el-alert @close="() => { tips.msg = ''; tips.type = 'error'; }" v-show="tips.msg" :title="tips.msg"
            :type="tips.type" show-icon>
          </el-alert>
        </div>
        <el-form :model="formData" ref="formDataRef" label-width="1px">
          <div>
            <el-form-item label="" prop="mobile" :rules="[
              { required: true, message: '请填写手机号' },
              { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写手机号' }
            ]" class="relative mb-[20]">
              <el-input size="large" class="large_input" placeholder="*请输入手机号" maxlength="11" v-model="formData.mobile">
              </el-input>
            </el-form-item>
            <el-form-item label="" class="mb-[20]" prop="catchcode" :rules="[{ required: true, message: '请输入验证码' }]">
              <div class="flex">
                <div class="relative flex-1 pr-[10]">
                  <el-input size="large" class="large_input" placeholder="请输入验证码" v-model="formData.catchcode">
                  </el-input>
                </div>
                <div class="verificationCode w-[130] " @click="getcaptcha">
                  <img :src="verificationCode" alt="" class="w-[100%]" />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="" prop="messagecode" :rules="[{ required: true, message: '请输入短信码' }]" class="mb-[20]">
              <div class="flex">
                <div class="relative flex-1 messagecode">
                  <el-input size="large" class="large_input" placeholder="请输入短信验证码" v-model="formData.messagecode">
                    <template v-slot:suffix>
                      <div
                        class="suffix cursor-pointer border-l-[1] border-[#d5dae5] border-solid w-[100] leading-[24] my-[9] t-[theme]"
                        @click="handleSend">{{ CountDownStatus ? "发送短信" :
                          `${CountDownNum}/s` }}</div>
                    </template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="pt-[16]">
            <el-button class="w-[100%]" type="primary" @click="handlerVerification('formDataRef')">下一步</el-button>
          </div>

        </el-form>

      </div>
    </div>
    <dg-copyright></dg-copyright>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import CountDown from "@/assets/js/countDown";
export default {
  mixins: [mixin],
  data() {
    return {
      tips: {
        msg: '',
        type: 'error'
      },
      CountDownNum: 60,
      CountDownStatus: true,
      verificationCode: "",
      formData: {
        loginName: "", // 账户名 17750877007
        password: "", // 123456  密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密
        catchcode: "", // 图形验证码
        messagecode: "", // 短信验证码
        mobile: "" // 手机号
      },
      countDown: {}
    };
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 登录
     */
    async handlerVerification(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          ajax.post({
            url: "/supplyChain/auth/checkSmsCode",
            data:
            // http://api.jfyancheng.com:8080/doc.html#/default/%E5%AE%98%E7%BD%91%E5%89%8D%E5%8F%B0-%E8%AE%A4%E8%AF%81%E6%A8%A1%E5%9D%97/checkSmsCodeUsingPOST
            {
              catchcode: this.formData.messagecode,  // 短信验证码 
              mobile: this.formData.mobile,  // 手机号 
            },
            self: this,
            success: res => {
              if (res) {
                this.$router.push({ path: '/modifyPaswLast' })
                sessionStorage.setItem('modifyPaswLast_phone', this.formData.mobile)
              }
            },
            fail: () => {

              this.getcaptcha()
            }
          });
        }
      });
    },

    /**
     * @author 伟健 / 张
     * @name 发送短信
     */
    handleSend() {
      if (!this.countDown.checkStatus()) {
        return;
      }
      let error = true
      this.$refs.formDataRef.validateField(['mobile', 'catchcode'], (errorMessage) => {
        if (errorMessage) {
          error = false // 校验失败时的提示信息
        }
      });
      if (error) {
        ajax.post({
          url: "/supplyChain/common/sendSmsCode",
          data: {
            catchcode: this.formData.catchcode, // 图形验证码
            mobile: this.formData.mobile // 手机号码
          },
          self: this,
          success: res => {
            if (res) {
              this.countDown.start();
            }
          },
          fail: () => {

            this.getcaptcha();
          }
        });
      }




    },
    /**
     * @author 伟健 / 张
     * @name 获取图像码
     */
    getcaptcha() {
      ajax.post({
        url: "/supplyChain/common/getcaptcha",
        data: {},
        self: this,
        success: res => {
          if (res) {
            this.verificationCode = res;
          }
        },
        fail: () => { }
      });
    },


  },
  mounted() {
    this.countDown = new CountDown({
      self: this,
      /*   这两参数必填
       "CountDownNum": 30,
       "CountDownStatus": true,
       */
      id: "forgetPasw"
    });
  },
  created() {
    this.getcaptcha();
  }
};
</script>

<style lang="less" scoped>
@import '~@/assets/css/var.less';
.shadow {
  box-shadow: 0 2px 10px 0 rgba(45, 72, 97, .1);
}
</style>
 <style>.pb-\[10\] {
    padding-bottom: 10px
}
.bg-\[\#fff\] {
    background-color: #fff
}
.h-\[100\%\] {
    height: 100%
}
.pr-\[40\] {
    padding-right: 40px
}
.min-h-\[84vh\] {
    min-height: 84vh
}
.pt-\[84\] {
    padding-top: 84px
}
.w-\[400\] {
    width: 400px
}
.mx-\[auto\] {
    margin-left: auto;
    margin-right: auto
}
.t-\[24\] {
    font-size: 24px
}
.pb-\[24\] {
    padding-bottom: 24px
}
.t-\[\#333\] {
    color: #333
}
.pb-\[5\] {
    padding-bottom: 5px
}
.mb-\[20\] {
    margin-bottom: 20px
}
.pr-\[10\] {
    padding-right: 10px
}
.w-\[130\] {
    width: 130px
}
.w-\[100\%\] {
    width: 100%
}
.border-l-\[1\] {
    border-left-width: 1px
}
.border-\[\#d5dae5\] {
    border-color: #d5dae5
}
.w-\[100\] {
    width: 100px
}
.leading-\[24\] {
    line-height: 24px
}
.my-\[9\] {
    margin-top: 9px;
    margin-bottom: 9px
}
.t-\[theme\] {
    color: #008AA6
}
.pt-\[16\] {
    padding-top: 16px
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.cursor-pointer {
    cursor: pointer
}
.text-center {
    text-align: center
}
.font-500 {
    font-weight: 500
}
.relative {
    position: relative
}
.flex-1 {
    flex: 1 1 0%
}
.border-solid {
    border-style: solid
}</style>